import { useEffect } from 'react';
import { languageService } from 'js/services/language.service';

import { useSetUserLang } from './useSetUserLang';

export const usePathLang = ({ isWaiting, pathLang, userLang }) => {
    const setUserLang = useSetUserLang();

    useEffect(() => {
        if (isWaiting || !pathLang) {
            return;
        }

        const calculatedLang = languageService.getLanguage(pathLang);

        if (calculatedLang !== userLang) {
            setUserLang(calculatedLang);
        }
    }, [isWaiting, pathLang, setUserLang, userLang]);
};
